const GrowthSection = () => {
    return (
        <section className="basic-area growth-area">
            <div className="container">
                <div className="basic-flex growth">
                    <img
                        className="basic-flex__image"
                        src="/images/activityDetails.gif"
                        alt="growth"
                    />

                    <div className="basic-flex__content">
                        <h2>Review your strengths and growth areas</h2>

                        <div>
                            You can also browse the questions that were asked
                            for each categories
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GrowthSection;
